import { render, staticRenderFns } from "./PhoneIcon.vue?vue&type=template&id=00a88e94&scoped=true"
var script = {}
import style0 from "./PhoneIcon.vue?vue&type=style&index=0&id=00a88e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a88e94",
  null
  
)

export default component.exports